import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PROJECT} from '../../constants';

export default {
  id: 'CREATE_OPER',
  title: 'Come posso creare un\'operazione?',
  description: '',
  categories: [CONTENT_CATEGORY_PROJECT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Per creare un\'operazione:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Fare clic sulla scheda «Operazioni»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_CREATE_OPER/IT_CREATE_OPER_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Fare clic su «Aggiungere una nuova operazione»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_CREATE_OPER/IT_CREATE_OPER_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Scegliere il tipo di operazione da creare'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_CREATE_OPER/IT_CREATE_OPER_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Scegli il tuo ruolo in questa operazione'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_CREATE_OPER/IT_CREATE_OPER_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Inserisci le informazioni relative all\'operazione'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_CREATE_OPER/IT_CREATE_OPER_5.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '6.',
    value: 'Confermare'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_CREATE_OPER/IT_CREATE_OPER_6.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Non vi resta che selezionare i documenti richiesti e dare accesso all\'operazione ai vostri collaboratori. (Vedi categoria «Le mie operazioni»).'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Se non hai la possibilità di creare un\'operazione, contatta il tuo Servizio Clienti.'
  }]
};
